<template>
  <div class="d-flex flex-wrap" v-if="isLoad">
    <div class="psychologist_wrapper my-skeleton-wrapper" v-for="n in 8" :key="n">
      <v-skeleton-loader
        width="370"
        height="490"
        :key="n.id"
        v-bind="attrs"
        type="card-avatar, article, actions"
      ></v-skeleton-loader>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Preloader',
  props: {
    isLoad: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      attrs: {
        boilerplate: false,
        elevation: 4
      }
    }
  }
}
</script>

<style scoped>
.my-skeleton-wrapper ::v-deep(.v-skeleton-loader__heading),
.my-skeleton-wrapper ::v-deep(.v-skeleton-loader__text),
.my-skeleton-wrapper ::v-deep(.v-skeleton-loader__avatar),
.my-skeleton-wrapper ::v-deep(.v-skeleton-loader__button),
.my-skeleton-wrapper ::v-deep(.v-skeleton-loader__image) {
  background: rgb(197, 210, 219);
}

.psychologist_wrapper {
  padding-top: 20px;
  padding-bottom: 20px;
}
</style>
